import React from "react";
import UserTable from "../../../components/UserTable";

const UserSearchTable = () => <UserTable />;

export default UserSearchTable;
